(function () {
  if (window.customElements.get("dc-gallery")) return;

  const VARIANT_EVENT = "douxcou:variant-change";
  const MAIN_ATC_ID = "main-atc";
  const OFFER_EVENT = "douxcou:offer-change";
  const emitVariant = (variantId, source) =>
    document.dispatchEvent(new CustomEvent(VARIANT_EVENT, { detail: { variantId: String(variantId), source } }));

  class DcGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-track]");
      this.thumbs = this.querySelector("[data-thumbs]");
      this.prevBtn = this.querySelector("[data-gallery-prev]");
      this.nextBtn = this.querySelector("[data-gallery-next]");
      this.count = this.track ? this.track.children.length : 0;
      this.index = Number(this.dataset.initial || 0);
      try {
        this.variantMedia = JSON.parse(this.querySelector("[data-variant-media]").textContent);
      } catch (e) {
        this.variantMedia = {};
      }

      this.onTrackScroll = this.onTrackScroll.bind(this);
      this.updateEdges = this.updateEdges.bind(this);
      this.onVariant = (e) => {
        const media = this.variantMedia[e.detail.variantId];
        if (typeof media === "number") this.go(media);
      };

      this.track && this.track.addEventListener("scroll", this.onTrackScroll, { passive: true });
      this.thumbs && this.thumbs.addEventListener("scroll", this.updateEdges, { passive: true });
      window.addEventListener("resize", this.updateEdges);
      document.addEventListener(VARIANT_EVENT, this.onVariant);

      this.addEventListener("click", (e) => {
        const goto = e.target.closest("[data-gallery-goto]");
        if (goto) return this.go(Number(goto.dataset.galleryGoto));
        if (e.target.closest("[data-gallery-prev]")) return this.go(this.index - 1);
        if (e.target.closest("[data-gallery-next]")) return this.go(this.index + 1);
        if (e.target.closest("[data-thumbs-prev]")) return this.scrollThumbs(-1);
        if (e.target.closest("[data-thumbs-next]")) return this.scrollThumbs(1);
        // Les visiteuses tapent sur la photo pour l'agrandir (clics « morts » dans les stats) : plein écran
        if (e.target.closest("[data-track] img") && !e.target.closest("a, button")) return this.openZoom();
      });

      this.sync("auto");
      this.updateEdges();

      // Photos 2+ : chargées après la page, ou dès que la cliente touche la galerie
      this.hydrate = () => {
        this.querySelectorAll("img[data-src]").forEach((img) => {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute("data-src");
          img.removeAttribute("data-srcset");
        });
      };
      ["pointerdown", "touchstart"].forEach((ev) => this.addEventListener(ev, this.hydrate, { once: true, passive: true }));
      this.track && this.track.addEventListener("scroll", this.hydrate, { once: true, passive: true });
      document.addEventListener(VARIANT_EVENT, this.hydrate, { once: true });
      const later = () => setTimeout(this.hydrate, 1500);
      document.readyState === "complete" ? later() : window.addEventListener("load", later, { once: true });
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.updateEdges);
      document.removeEventListener(VARIANT_EVENT, this.onVariant);
      clearTimeout(this.timer);
    }

    step() {
      const li = this.track && this.track.children;
      return li && li.length > 1 ? li[1].offsetLeft - li[0].offsetLeft : this.track ? this.track.clientWidth : 0;
    }

    go(i) {
      const next = Math.max(0, Math.min(this.count - 1, i));
      this.index = next;
      this.sync("smooth");
    }

    sync(behavior) {
      const i = this.index;
      const track = this.track;
      if (track) {
        const left = i * this.step();
        if (Math.abs(track.scrollLeft - left) > 1) track.scrollTo({ left, behavior });
      }
      const thumbs = this.thumbs;
      const li = thumbs && thumbs.children[i];
      if (thumbs && li) {
        const l = li.offsetLeft - thumbs.offsetLeft;
        if (l < thumbs.scrollLeft || l + li.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) {
          thumbs.scrollTo({ left: l - 5, behavior });
        }
      }
      this.render();
    }

    render() {
      const i = this.index;
      if (this.track) {
        [...this.track.children].forEach((li, n) => li.setAttribute("aria-current", n === i ? "true" : "false"));
      }
      this.querySelectorAll("[data-gallery-dot]").forEach((dot, n) => dot.classList.toggle("is-active", n === i));
      this.querySelectorAll("[data-gallery-thumb]").forEach((btn, n) => {
        btn.classList.toggle("is-active", n === i);
        if (n === i) btn.setAttribute("aria-current", "true");
        else btn.removeAttribute("aria-current");
      });
      [
        [this.prevBtn, i === 0],
        [this.nextBtn, i === this.count - 1],
      ].forEach(([btn, disabled]) => {
        if (!btn) return;
        btn.disabled = disabled;
        btn.classList.toggle("cursor-default", disabled);
        btn.classList.toggle("opacity-30", disabled);
        btn.classList.toggle("cursor-pointer", !disabled);
      });
    }

    onTrackScroll() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const s = this.step();
        if (!this.track || !s) return;
        const i = Math.max(0, Math.min(this.count - 1, Math.round(this.track.scrollLeft / s)));
        if (i !== this.index) {
          this.index = i;
          this.sync("smooth");
        }
      }, 100);
    }

    updateEdges() {
      const t = this.thumbs;
      if (!t) return;
      const prev = this.querySelector("[data-thumbs-prev]");
      const next = this.querySelector("[data-thumbs-next]");
      if (prev) prev.disabled = t.scrollLeft <= 1;
      if (next) next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
    }

    openZoom() {
      const imgs = [...this.track.children].map((li) => li.querySelector("img")).filter(Boolean);
      if (!imgs.length) return;
      if (!document.getElementById("dc-zoom-style")) {
        const st = document.createElement("style");
        st.id = "dc-zoom-style";
        st.textContent = `.dc-zoom{position:fixed;inset:0;z-index:2147483001;background:#18110d;display:flex;flex-direction:column}
.dc-zoom__bar{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;color:#fff;font-size:15px}
.dc-zoom__close{width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;font-size:26px;line-height:44px;cursor:pointer}
.dc-zoom__track{flex:1;display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}
.dc-zoom__track::-webkit-scrollbar{display:none}
.dc-zoom__slide{flex:0 0 100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;padding:0 0 24px}
.dc-zoom__slide img{max-width:100%;max-height:100%;object-fit:contain;touch-action:pinch-zoom}
[data-track] img{cursor:zoom-in}`;
        document.head.appendChild(st);
      }
      const big = (img) => (img.dataset.src || img.currentSrc || img.src).replace(/([?&])width=\d+/, "$1width=1800");
      const box = document.createElement("div");
      box.className = "dc-zoom";
      box.setAttribute("role", "dialog");
      box.setAttribute("aria-modal", "true");
      box.setAttribute("aria-label", "Photos en grand");
      box.innerHTML = `<div class="dc-zoom__bar"><span data-zoom-count></span><button type="button" class="dc-zoom__close" aria-label="Fermer">×</button></div><div class="dc-zoom__track"></div>`;
      const track = box.querySelector(".dc-zoom__track");
      const count = box.querySelector("[data-zoom-count]");
      imgs.forEach((img) => {
        const slide = document.createElement("div");
        slide.className = "dc-zoom__slide";
        const el = document.createElement("img");
        el.src = big(img);
        el.alt = img.alt || "";
        slide.appendChild(el);
        track.appendChild(slide);
      });
      const current = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
      const show = () => (count.textContent = `${current() + 1} / ${imgs.length}`);
      const close = () => {
        this.go(current());
        box.remove();
        document.body.classList.remove("overflow-hidden");
        document.removeEventListener("keydown", onKey);
      };
      const onKey = (e) => {
        if (e.key === "Escape") close();
        if (e.key === "ArrowRight") track.scrollBy({ left: track.clientWidth, behavior: "smooth" });
        if (e.key === "ArrowLeft") track.scrollBy({ left: -track.clientWidth, behavior: "smooth" });
      };
      box.querySelector(".dc-zoom__close").addEventListener("click", close);
      // Toucher le fond (hors photo) referme aussi
      track.addEventListener("click", (e) => { if (e.target.tagName !== "IMG") close(); });
      track.addEventListener("scroll", show, { passive: true });
      document.addEventListener("keydown", onKey);
      document.body.appendChild(box);
      document.body.classList.add("overflow-hidden");
      track.scrollLeft = this.index * track.clientWidth;
      show();
      box.querySelector(".dc-zoom__close").focus();
    }

    scrollThumbs(dir) {
      const t = this.thumbs;
      const first = t && t.children[0];
      if (!first) return;
      t.scrollBy({ left: dir * (first.offsetWidth + 10), behavior: "smooth" });
    }
  }

  class DcProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.button = this.querySelector("[data-atc]");
      this.error = this.querySelector("[data-error]");
      if (!this.form) return;

      this.form.addEventListener("click", (e) => {
        // Tap sur la vignette d'une ligne de couleur (clics « morts » dans les stats) : couleur suivante
        const rowImg = e.target.closest("[data-row-image]");
        if (rowImg) {
          const sw = [...rowImg.closest("[data-row]").querySelectorAll("[data-swatch]")];
          const cur = sw.findIndex((b) => b.getAttribute("aria-pressed") === "true");
          if (sw.length) sw[(cur + 1) % sw.length].click();
          return;
        }
        const swatch = e.target.closest("[data-swatch]");
        if (swatch) {
          e.preventDefault();
          const select = swatch.closest("[data-row]").querySelector("[data-row-select]");
          if (select.value !== swatch.dataset.swatch) {
            select.value = swatch.dataset.swatch;
            select.dispatchEvent(new Event("change", { bubbles: true }));
          }
          return;
        }
        const row = e.target.closest("[data-upsell-row]");
        if (!row) return;
        const offer = row.closest("[data-offer]");
        if (offer !== this.selectedOffer()) return;
        if (e.target.matches("[data-upsell]")) return;
        e.preventDefault();
        const box = row.querySelector("[data-upsell]");
        box.checked = !box.checked;
        this.updatePrices();
      });
      this.form.addEventListener("change", (e) => {
        if (e.target.closest("[data-upsell]")) return this.updatePrices();
        const input = e.target.closest("[data-offer-input]");
        if (input) return this.markSelected();
        const select = e.target.closest("[data-row-select]");
        if (select) {
          const opt = select.selectedOptions[0];
          const rowEl = select.closest("[data-row]");
          const img = rowEl.querySelector("[data-row-image]");
          if (img && opt && opt.dataset.image) img.src = opt.dataset.image;
          const name = rowEl.querySelector("[data-row-name]");
          if (name && opt) name.textContent = opt.textContent.trim();
          rowEl.querySelectorAll("[data-swatch]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.swatch === select.value)));
          emitVariant(select.value, "bundle");
        }
      });
      this.form.addEventListener("submit", (e) => this.onSubmit(e));
      const buy = this.querySelector("[data-buy-now]");
      if (buy) buy.addEventListener("click", () => this.buyNow(buy));
      this.markSelected();
      this.renderDelivery();
    }

    renderDelivery() {
      const el = this.querySelector("[data-delivery]");
      const text = el && el.querySelector("[data-delivery-text]");
      const min = Number(el && el.dataset.min);
      const max = Number(el && el.dataset.max);
      if (!text || !min || !max) return;
      const addBusinessDays = (n) => {
        const d = new Date();
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) n--;
        }
        return d;
      };
      const fmt = new Intl.DateTimeFormat("fr-FR", { weekday: "short", day: "numeric", month: "short" });
      text.innerHTML = `Livraison offerte : reçue entre le <strong>${fmt.format(addBusinessDays(min))}</strong> et le <strong>${fmt.format(addBusinessDays(max))}</strong>`;
      // Date limite pour Noël : dernier jour où le délai MAXIMAL annoncé tombe encore avant le 24/12 (jamais une date inventée)
      const xmasEl = el.parentNode.querySelector("[data-xmas]");
      if (xmasEl) {
        const now = new Date();
        const xmas = new Date(now.getMonth() === 11 && now.getDate() > 24 ? now.getFullYear() + 1 : now.getFullYear(), 11, 24);
        const limit = new Date(xmas);
        let n = max;
        while (n > 0) {
          limit.setDate(limit.getDate() - 1);
          if (limit.getDay() !== 0 && limit.getDay() !== 6) n--;
        }
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const days = Math.round((limit - today) / 864e5);
        if (days >= 0 && days <= 60) {
          const long = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long" });
          xmasEl.querySelector("[data-xmas-text]").innerHTML = `Pour Noël : commande avant le <strong>${long.format(limit)}</strong> pour la recevoir à temps`;
          xmasEl.hidden = false;
        }
      }
    }

    selectedOffer() {
      const input = this.form.querySelector("[data-offer-input]:checked");
      return input ? input.closest("[data-offer]") : this.form.querySelector("[data-offer]");
    }

    markSelected() {
      const selected = this.selectedOffer();
      // Les couleurs déjà choisies suivent quand on change d'offre (sinon un « Blanc » choisi dans l'offre 2 redevenait Gris en passant à 1)
      const prev = this.lastOffer;
      if (prev && prev !== selected) {
        const from = [...prev.querySelectorAll("[data-row-select]")].map((s) => s.value);
        selected.querySelectorAll("[data-row-select]").forEach((s, i) => {
          const v = from[Math.min(i, from.length - 1)];
          if (v && s.value !== v) {
            s.value = v;
            s.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }
      this.lastOffer = selected;
      this.form.querySelectorAll("[data-offer]").forEach((o) => o.classList.toggle("is-selected", o === selected));
      this.updatePrices();
    }

    updatePrices() {
      const selected = this.selectedOffer();
      const euro = (cents) => (cents / 100).toFixed(2).replace(".", ",") + "\u00a0€";
      this.form.querySelectorAll("[data-offer]").forEach((o) => {
        const prices = o.querySelector(".dc-offer__prices");
        if (!prices) return;
        const priceEl = prices.querySelector("[data-offer-price]");
        const compare = prices.querySelector("[data-offer-compare]");
        const optionsEl = prices.querySelector("[data-offer-options]");
        const isSel = o === selected;
        const boxes = [...o.querySelectorAll("[data-upsell]")];
        if (!isSel) boxes.forEach((b) => (b.checked = false));
        const options = boxes.filter((b) => b.checked).reduce((n, b) => n + Number(b.dataset.cents || 0), 0);
        const base = Math.round(parseFloat((prices.dataset.price || "").replace(/[^\d,.]/g, "").replace(",", ".")) * 100);
        if (options && base) {
          priceEl.textContent = euro(base + options);
          optionsEl.textContent = "dont options +" + euro(options);
          optionsEl.hidden = false;
        } else {
          priceEl.textContent = prices.dataset.price;
          optionsEl.hidden = true;
        }
        if (compare) compare.hidden = !!options;
        prices.classList.toggle("has-compare", !!compare && !options);
      });
      const sel = selected && selected.querySelector(".dc-offer__prices");
      if (sel) {
        const compare = sel.querySelector("[data-offer-compare]");
        this.offer = {
          title: sel.dataset.title || "",
          price: sel.querySelector("[data-offer-price]").textContent.trim(),
          compare: compare && !compare.hidden ? compare.textContent.trim() : "",
        };
        document.dispatchEvent(new CustomEvent(OFFER_EVENT, { detail: this.offer }));
        // Le bouton dit ce qu'il ajoute : l'offre « 2 écharpes » est cochée d'office, on ne doit pas la découvrir au panier
        if (this.button && !this.button.disabled && this.offer.title) {
          // Espaces insécables : le « € » ne part jamais seul à la ligne sur mobile
          const label = `Ajouter ${this.offer.title} · ${String(this.offer.price).replace(/ /g, " ")}`;
          this.button.dataset.label = label;
          if (this.button.getAttribute("aria-busy") !== "true" && !this.button.classList.contains("is-added")) this.button.textContent = label;
        }
      }
    }

    items() {
      const offer = this.selectedOffer();
      const counts = new Map();
      if (offer) {
        offer.querySelectorAll("[data-row-select]").forEach((s) => counts.set(s.value, (counts.get(s.value) || 0) + 1));
      }
      const items = [...counts].map(([id, quantity]) => ({ id: Number(id), quantity }));
      if (offer) offer.querySelectorAll("[data-upsell]:checked").forEach((b) => items.push({ id: Number(b.value), quantity: 1 }));
      return items;
    }

    async buyNow(btn) {
      const items = this.items();
      if (!items.length || btn.getAttribute("aria-busy") === "true") return;
      btn.setAttribute("aria-busy", "true");
      const label = btn.innerHTML;
      btn.innerHTML = `<span class="cozy-btn__spinner" aria-hidden="true"></span>Ouverture du paiement…`;
      this.error.hidden = true;
      try {
        if (window.Douxcou && window.Douxcou.cart) await window.Douxcou.cart.add(items, { openDrawer: false });
        else {
          const r = await fetch(`${window.routes.cart_add_url}.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items }) });
          if (!r.ok) throw new Error((await r.json()).description || "Impossible d'ajouter au panier.");
        }
        window.location.href = `${window.routes.root_url.replace(/\/$/, "")}/checkout`;
      } catch (err) {
        btn.removeAttribute("aria-busy");
        btn.innerHTML = label;
        this.error.textContent = err.message || "Impossible d'ouvrir le paiement.";
        this.error.hidden = false;
      }
    }

    async onSubmit(e) {
      const items = this.items();
      if (!items.length) return;
      if (!window.Douxcou || !window.Douxcou.cart) {
        if (!this.form.querySelector('[name="id"]')) {
          const id = document.createElement("input");
          id.type = "hidden";
          id.name = "id";
          id.value = items[0].id;
          this.form.appendChild(id);
        }
        return;
      }
      e.preventDefault();
      if (this.button.getAttribute("aria-busy") === "true") return;
      const sticky = document.querySelector("[data-sticky-button]");
      const buttons = [this.button, sticky].filter(Boolean);
      // Retour visuel immédiat : spinner + « Ajout en cours… », puis coche « Ajouté ! » avant de rendre le libellé
      const setState = (state) =>
        buttons.forEach((b) => {
          if (b.dataset.label === undefined) b.dataset.label = b.innerHTML;
          clearTimeout(b._atcTimer);
          b.classList.remove("is-added");
          if (state === "loading") {
            b.setAttribute("aria-busy", "true");
            b.innerHTML = `<span class="cozy-btn__spinner" aria-hidden="true"></span>${b === sticky ? "Ajout…" : "Ajout en cours…"}`;
          } else {
            b.removeAttribute("aria-busy");
            if (state === "added") {
              b.classList.add("is-added");
              b.innerHTML = `<svg class="cozy-btn__check" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Ajouté !`;
              b._atcTimer = setTimeout(() => setState(null), 1600);
            } else {
              b.innerHTML = b.dataset.label;
            }
          }
        });
      setState("loading");
      this.button.disabled = true;
      this.error.hidden = true;
      try {
        await window.Douxcou.cart.add(items, { openDrawer: true });
        setState("added");
      } catch (err) {
        setState(null);
        this.error.textContent = err.message || "Impossible d'ajouter au panier.";
        this.error.hidden = false;
      } finally {
        this.button.disabled = false;
      }
    }
  }

  class DcInlineReviews extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector("[data-viewport]");
      this.track = this.querySelector("[data-track]");
      this.slides = [...this.querySelectorAll("[data-slide]")];
      this.prev = this.querySelector("[data-prev]");
      this.next = this.querySelector("[data-next]");
      this.index = 0;
      this.measure = this.measure.bind(this);
      this.prev && this.prev.addEventListener("click", () => this.go(this.index - 1));
      this.next && this.next.addEventListener("click", () => this.go(this.index + 1));
      window.addEventListener("resize", this.measure);
      this.onBlockSelect = (e) => {
        const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
        if (i > -1) this.go(i);
      };
      document.addEventListener("shopify:block:select", this.onBlockSelect);
      this.go(0);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.measure);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    go(i) {
      const last = this.slides.length - 1;
      this.index = Math.max(0, Math.min(last, i));
      this.track.style.transform = `translateX(calc(${-this.index} * (100% + 45px)))`;
      this.slides.forEach((s, n) => {
        if (n === this.index) s.removeAttribute("aria-hidden");
        else s.setAttribute("aria-hidden", "true");
      });
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === last;
      this.measure();
    }

    measure() {
      const el = this.slides[this.index];
      if (el) this.viewport.style.height = `${el.getBoundingClientRect().height}px`;
    }
  }

  class DcFaq extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("button");
      this.button.addEventListener("click", () => this.toggle());
      this.onBlockSelect = (e) => {
        if (e.detail.blockId === this.dataset.blockId) this.toggle(true);
      };
      document.addEventListener("shopify:block:select", this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    toggle(force) {
      const open = typeof force === "boolean" ? force : !this.classList.contains("is-open");
      this.classList.toggle("is-open", open);
      this.button.setAttribute("aria-expanded", String(open));
    }
  }

  class DcStickyAtc extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector("[data-bar]");
      this.select = this.querySelector("[data-sticky-select]");
      this.image = this.querySelector("[data-sticky-image]");
      this.price = this.querySelector("[data-variant-price]");
      this.button = this.querySelector("[data-sticky-button]");
      this.visible = false;
      this.raf = 0;

      this.check = () => {
        this.raf = 0;
        // Visible dès l'arrivée (la moitié des visiteuses ne défilent pas), sauf quand le bouton principal est à l'écran
        const el = document.getElementById(MAIN_ATC_ID);
        if (!el) return this.setVisible(false);
        const r = el.getBoundingClientRect();
        const mainInView = r.top < window.innerHeight && r.bottom > 0;
        this.setVisible(!mainInView);
      };
      this.onScroll = () => {
        if (!this.raf) this.raf = requestAnimationFrame(this.check);
      };
      this.onVariant = (e) => this.showVariant(e.detail.variantId);
      this.offerTitle = this.querySelector("[data-sticky-offer]");
      this.offerPrice = this.querySelector("[data-sticky-price]");
      this.offerCompare = this.querySelector("[data-sticky-compare]");
      this.onOffer = (e) => this.showOffer(e.detail);

      window.addEventListener("scroll", this.onScroll, { passive: true });
      window.addEventListener("resize", this.onScroll);
      document.addEventListener(VARIANT_EVENT, this.onVariant);
      document.addEventListener(OFFER_EVENT, this.onOffer);
      const form = document.querySelector("dc-product-form");
      if (form && form.offer) this.showOffer(form.offer);

      this.button.addEventListener("click", () => {
        const main = document.getElementById(MAIN_ATC_ID);
        if (main) main.click();
      });
      if (this.select) {
        this.select.addEventListener("change", () => emitVariant(this.select.value, "sticky"));
      }
      this.check();
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScroll);
      window.removeEventListener("resize", this.onScroll);
      document.removeEventListener(VARIANT_EVENT, this.onVariant);
      document.removeEventListener(OFFER_EVENT, this.onOffer);
      if (this.raf) cancelAnimationFrame(this.raf);
      document.body.classList.remove("sticky-atc-visible");
    }

    setVisible(visible) {
      if (visible === this.visible) return;
      this.visible = visible;
      this.bar.classList.toggle("translate-y-0", visible);
      this.bar.classList.toggle("translate-y-full", !visible);
      this.bar.setAttribute("aria-hidden", String(!visible));
      this.bar.inert = !visible;
      this.button.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle("sticky-atc-visible", visible);
    }

    showOffer({ title, price, compare }) {
      if (!this.offerPrice) return;
      this.offerPrice.textContent = price;
      if (this.offerTitle && title) {
        this.offerTitle.textContent = title;
        const prefix = this.querySelector("[data-sticky-prefix]");
        if (prefix) prefix.hidden = false;
      }
      if (this.offerCompare) {
        this.offerCompare.textContent = compare;
        this.offerCompare.hidden = !compare;
      }
    }

    showVariant(id) {
      if (!this.select) return;
      const opt = [...this.select.options].find((o) => o.value === id);
      if (!opt) return;
      this.select.value = id;
      if (this.image && opt.dataset.image) this.image.src = opt.dataset.image;
      if (opt.dataset.price && window.Douxcou && window.Douxcou.formatMoney) {
        const money = window.Douxcou.formatMoney(opt.dataset.price);
        document.querySelectorAll("[data-variant-price]").forEach((el) => (el.textContent = money));
      }
    }
  }

  customElements.define("dc-gallery", DcGallery);
  customElements.define("dc-product-form", DcProductForm);
  customElements.define("dc-inline-reviews", DcInlineReviews);
  customElements.define("dc-faq", DcFaq);
  customElements.define("dc-sticky-atc", DcStickyAtc);
})();

// Titre et pastilles « 5 couleurs » : tapés comme s'ils étaient cliquables (stats) → on amène aux offres
document.addEventListener("click", (e) => {
  if (!e.target.closest("[data-go-offres-tap]")) return;
  const offres = document.getElementById("offres");
  if (offres) offres.scrollIntoView({ behavior: "smooth", block: "start" });
});
